import Api from "entities/helpers/api";
import ErrorLogger from "entities/helpers/error-log-helper";
import EverTrue from "app";
import { useState } from "react";

const useEmailTemplatesApi = () => {
  const [loading, setLoading] = useState(true);

  const getEmailTemplates = async (offset = 0, limit) => {
    try {
      const res = await Api.OUTREACH.EMAIL_TEMPLATES.get({
        params: {
          offset,
          limit,
        },
      });
      return res;
    } catch (e) {
      ErrorLogger.error("Error getting email templates", { extra: { e, page_name: "Task Templates Modal" } });
      return EverTrue.Alert.error("There was a problem getting email template.");
    } finally {
      setLoading(false);
    }
  };

  const createEmailTemplate = async (template) => {
    try {
      const newTemplate = await Api.OUTREACH.EMAIL_TEMPLATES.post({
        data: JSON.stringify(template),
      });
      EverTrue.Alert.success("Email template created successfully");
      return newTemplate;
    } catch (e) {
      ErrorLogger.error("Error creating email templates", { extra: { e, page_name: "Task Templates Create Modal" } });
    } finally {
      setLoading(false);
    }
  };

  const updateEmailTemplate = async (templateId, oid, userId, { templateName, templateSubject, templateBody }) => {
    try {
      const updatedTemplate = await Api.OUTREACH.EMAIL_TEMPLATE.put({
        urlArgs: { id: templateId },
        data: JSON.stringify({
          templateName,
          templateSubject,
          templateBody,
          oid,
          userId,
        }),
      });
      EverTrue.Alert.success("Email template updated successfully");
      return updatedTemplate;
    } catch (e) {
      ErrorLogger.error("Error updating email template", { extra: { e, page_name: "Task Templates Create Modal" } });
    } finally {
      setLoading(false);
    }
  };

  const deleteTemplate = async (id, onSuccess) => {
    try {
      await Api.OUTREACH.EMAIL_TEMPLATE.delete({
        urlArgs: { id },
      });
      EverTrue.Alert.success("Email template deleted successfully");
      onSuccess();
    } catch (e) {
      ErrorLogger.error("Error deleting email template", { extra: { e, page_name: "Task Templates Modal" } });
      return EverTrue.Alert.error("There was a problem deleting the email template.");
    } finally {
      setLoading(false);
    }
  };

  const searchEmailTemplates = async (searchParam) => {
    try {
      setLoading(true);
      const res = await Api.OUTREACH.EMAIL_TEMPLATES_SEARCH.get({
        params: { template_name: searchParam },
      });
      return res;
    } catch (e) {
      ErrorLogger.error("Error searching email templates", { extra: { e, page_name: "Task Templates Modal" } });
      return EverTrue.Alert.error("There was a problem searching email templates.");
    } finally {
      setLoading(false);
    }
  };

  return { getEmailTemplates, createEmailTemplate, updateEmailTemplate, deleteTemplate, searchEmailTemplates, loading };
};

export default useEmailTemplatesApi;
